export const FirebaseConfig = {
	"projectId": "exicubebidcab",
	"appId": "1:120251456997:web:892da5dead6a239629630c",
	"databaseURL": "https://exicubebidcab-default-rtdb.firebaseio.com",
	"storageBucket": "exicubebidcab.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCPG1fX7Q6rrjK6k0OKWCHoGAEvF2GxpL4",
	"authDomain": "exicubebidcab.firebaseapp.com",
	"messagingSenderId": "120251456997",
	"projectNumber": "120251456997",
	"version": "2"
};